import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const clusterDetailRouteRef = createRouteRef({
  params: ['k8sClusterId'],
});
